import { z } from "zod";

export const TimeReportClient = z
  .object({
    name: z.string(),
    logo: z
      .object({
        publicUrl: z.string().nullish(),
      })
      .nullish(),
  })
  .passthrough();

export type TimeReportClient = z.infer<typeof TimeReportClient>;
